var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"inline-menu"},_vm._l((_vm.links),function(link,index){return _c('li',{key:index,staticClass:"inline-menu__item"},[_c('a',{staticClass:"inline-menu__link",attrs:{"href":link.href,"rel":_vm.isRel(link.rel)}},[_vm._v(_vm._s(link.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }